<div class="flex-basis">
    <button class="btn btn-clear btn-thin-pad" [ngClass]="{'btn-active': dir == 'asc'}" (click)="sort('asc')" tabindex="0" attr.aria-label="Sort by asc" attr.value="Sort by asc">
        <i class="fa fa-caret-down no-margin" attr.aria-hidden="true"></i>
        <span class="sr-only">Sort by asc</span>
    </button>
    <button class="btn btn-clear btn-thin-pad" [ngClass]="{'btn-active': dir == 'desc'}" (click)="sort('desc')" tabindex="0" attr.aria-label="Sort by desc">
        <i class="fa fa-caret-up" attr.aria-hidden="true"></i>
        <span class="sr-only">Sort by desc</span>
    </button>
</div>